import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

const router = [
  {
    path: "/",
    name: "default",
    redirect: "/info",
    meta: { title: "未成年退款信息" },
  },
  {
    path: "/r_zone_transfer",
    name: "r_zone_transfer",
    component: () => import("@views/r_zone_transfer/index.vue"),
    meta: { title: "转区服务" },
  },
  {
    path: "/r_zone_transfer_wechat",
    name: "r_zone_transfer_wechat",
    component: () => import("@views/r_zone_transfer_wechat/index.vue"),
    meta: { title: "转区服务" },
  },
  {
    path: "/r_zone_transfer_wechat_new",
    name: "r_zone_transfer_wechat_new",
    component: () => import("@views/r_zone_transfer_wechat_new/index.vue"),
    meta: { title: "转区服务" },
  },
  {
    path: "/boss_query",
    name: "boss_query",
    component: () => import("@views/boss_query/index.vue"),
    meta: { title: "俱乐部BOSS查询" },
  },
  {
    path: "/boss_query_new",
    name: "boss_query_new",
    component: () => import("@views/boss_query_new/index.vue"),
    meta: { title: "俱乐部BOSS查询" },
  },
  {
    path: "/info",
    name: "info",
    component: () => import("@views/customer_service/UserInfo.vue"),
    meta: { title: "未成年退款信息" },
  },
  {
    path: "/config",
    name: "config",
    component: () => import("@views/customer_service/ConfigInfo.vue"),
    meta: { title: "未成年退款信息" },
  },
  {
    path: "/result",
    name: "result",
    component: () => import("@views/customer_service/ResultPage.vue"),
    meta: { title: "未成年退款信息" },
  },
  // 大R信息收集
  {
    path: "/r_collect_info",
    name: "r_collect_info",
    component: () => import("@views/r_info_collect/index.vue"),
    meta: { title: "收货地址" },
  },
  {
    path: "/r_result",
    name: "r_result",
    component: () => import("@views/r_info_collect/result.vue"),
    meta: { title: "收货地址" },
  },
  {
    path: "/red_envelope",
    name: "red_envelope",
    component: () => import("@views/tools/red_envelope.vue"),
  },
  {
    path: "/redirect",
    name: "redirect",
    component: () => import("@views/redirect/index.vue"),
  },
  // 跳转到疯狂游戏社区工单
  {
    path: "/workorder",
    name: "redirect_wechat",
    component: () => import("@views/redirect_wechat/index.vue"),
  },
  {
    path: "/post_detail",
    name: "post_detail",
    component: () => import("@views/post_detail/index.vue"),
  },
];

export default new Router({
  mode: "history",
  routes: router,
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  },
});

